export type Theme = 'classic' | 'ocean' | 'sunset' | 'dark';
export type TimerMode = 'custom' | 'pomodoro';

export const themes = {
  classic: {
    bg: 'bg-gray-100',
    card: 'bg-white',
    primary: 'bg-blue-600 hover:bg-blue-700',
    secondary: 'bg-gray-200 hover:bg-gray-300',
    text: 'text-gray-800',
    textMuted: 'text-gray-600',
    border: 'border-gray-300',
    ring: 'focus:ring-blue-500',
    error: 'text-red-500',
    warningText: 'text-red-500',
    settingsPanel: 'bg-gray-50 border-gray-200',
    linkText: 'text-gray-400 hover:text-gray-600',
    fullscreen: 'bg-gray-900',
    fullscreenText: 'text-white',
    switch: {
      bg: 'bg-gray-200',
      bgActive: 'bg-blue-600',
      dot: 'bg-white'
    }
  },
  ocean: {
    bg: 'bg-cyan-50',
    card: 'bg-white',
    primary: 'bg-teal-600 hover:bg-teal-700',
    secondary: 'bg-cyan-100 hover:bg-cyan-200',
    text: 'text-slate-800',
    textMuted: 'text-slate-600',
    border: 'border-cyan-200',
    ring: 'focus:ring-teal-500',
    error: 'text-red-500',
    warningText: 'text-orange-500',
    settingsPanel: 'bg-cyan-50 border-cyan-200',
    linkText: 'text-cyan-600/40 hover:text-cyan-600/60',
    fullscreen: 'bg-slate-900',
    fullscreenText: 'text-cyan-50',
    switch: {
      bg: 'bg-cyan-200',
      bgActive: 'bg-teal-600',
      dot: 'bg-white'
    }
  },
  sunset: {
    bg: 'bg-amber-50',
    card: 'bg-white',
    primary: 'bg-orange-500 hover:bg-orange-600',
    secondary: 'bg-amber-100 hover:bg-amber-200',
    text: 'text-slate-800',
    textMuted: 'text-slate-600',
    border: 'border-amber-200',
    ring: 'focus:ring-orange-500',
    error: 'text-red-500',
    warningText: 'text-red-500',
    settingsPanel: 'bg-amber-50 border-amber-200',
    linkText: 'text-amber-600/40 hover:text-amber-600/60',
    fullscreen: 'bg-slate-900',
    fullscreenText: 'text-amber-50',
    switch: {
      bg: 'bg-amber-200',
      bgActive: 'bg-orange-500',
      dot: 'bg-white'
    }
  },
  dark: {
    bg: 'bg-gray-900',
    card: 'bg-gray-800',
    primary: 'bg-indigo-600 hover:bg-indigo-700',
    secondary: 'bg-gray-700 hover:bg-gray-600',
    text: 'text-gray-100',
    textMuted: 'text-gray-400',
    border: 'border-gray-700',
    ring: 'focus:ring-indigo-500',
    error: 'text-red-400',
    warningText: 'text-red-400',
    settingsPanel: 'bg-gray-800 border-gray-700',
    linkText: 'text-gray-600 hover:text-gray-500',
    fullscreen: 'bg-black',
    fullscreenText: 'text-gray-100',
    switch: {
      bg: 'bg-gray-700',
      bgActive: 'bg-indigo-600',
      dot: 'bg-gray-100'
    }
  }
} as const;